import { combineReducers } from "redux";
import SettingReducer from "./Settings.reducer";
import ComponentReducer from "./Component.reducer";

export default combineReducers({
  SettingResponse: SettingReducer,
  ComponentResponse: ComponentReducer,
});
